import SideTabMenu from './SideTabMenu';

export default SideTabMenu;
